module.exports = __webpack_public_path__ + "static/media/BabyBoy_XFL.213498b8.png";